import { useState, useEffect } from "react";
import { Table as antdTable } from "antd";
import InputSearch from './Search'
import styled from "styled-components";

const Container = styled.div`

  .data-length{
    width: 100%;
    text-align: center;
  }

  .top-button{
    display: flex;
    justify-content: space-between;
  }
`;
const Table = styled(antdTable)`
  margin-top: 5px;
  border: 1.5px solid #E8E8E8;
  border-radius: 5px;
  .ant-table { 
    overflow-x: auto; 
    border-top-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
  }

  .ant-table-tbody > tr{
    &.odd{
      /* td{ background-color: #69ACF4} */
    }
  }

  .ant-table-thead > tr > th {
    background-color: #69ACF4;
    padding: 8px 16px;
    color: #FFF;
    @media only screen and (max-width: 768px) {
      font-size: 16px;    
    }
    @media only screen and (max-width: 450px) {
      font-size: 14px;    
    }
    @media only screen and (max-width: 376px) {
      font-size: 12px;    
    }
    @media only screen and (min-width: 1200px) {
      font-size : 16px;
  }

    :first-child{
      border-top-left-radius: 5px !important;
      .ant-table-column-sorters{
        ::after{
      border-top-left-radius: 5px !important;
      }
      }

    }
    &:hover { background: #69ACF4 !important}

    span{ 
      text-align: center !important;
      
    }
  }

  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    &.ant-table-column-sort { background: transparent !important;}
  }

  .ant-table-pagination{
    display: ${ props => props.disabledPagination ? "none": "flex"};
  }
`;

export default function Index(props) {
  const [mode, setMode] = useState('data')
  const [filterData, setFilterData] = useState([]) 
  const [allowSearch, setAllowSearch] = useState(null)

  useEffect(() => {
  }, [allowSearch])

  const filterByValue = (e) => {
    let value = e.target.value

    !value || value === '' ? setMode('data') : setMode('filter')
    
    let newData = props.data.filter((entry) => {
      let isIncludes = false;
      Object.keys(entry).map((key) => {
        if ( entry[key] !== null && entry[key] !== true && entry[key] !== false 
            && entry[key].toString().toLowerCase().includes(value.toLowerCase()) && !isIncludes 
            && allowSearch.indexOf(key) >= 0
            && props.columns.some(o => o.dataIndex)) {
              isIncludes = true;
            };
      });
      return isIncludes;
    });

    setFilterData(newData)
  };
  return (
    <Container className="table">
      <div className="table__container">
        <div className="top-button">
          { !props.disabledSearch ?  <InputSearch filterByValue={filterByValue} columns={props.columns} allowSearch={allowSearch} setAllowSearch={setAllowSearch}/> : <div></div> }
          { props.topRightButton ?  props.topRightButton : "" }
          
        </div>
        <Table
          rowClassName={(record, index) => index % 2 === 0 ? "even" : "odd"}
          className={ "table-control " + (props.className ? props.className : "") }
          id={props.dataSet}
          rowSelection={props.rowSelection}
          rowKey={props.rowKey ? props.rowKey : "id"}
          columns={props.columns}
          pagination={{ position: ["bottomCenter"] }}
          disabledPagination={props.disabledPagination}
          dataSource={ mode === 'data' ? props.data : filterData}
          expandable={props.expandable ? props.expandable : false}
          // loading={props.loading ? props.loading : props.data.length > 0 ? false : true}
        ></Table>
        {/* { !props.disabledDataLength ?  <label className="data-length"> จำนวนข้อมูลที่แสดง{" "}{ mode === 'data' ? props.data.length : filterData.length} แถว</label> : "" } */}
      </div>
    </Container>
  );
}
